import React from 'react';
import { motion } from 'framer-motion';
import { getColor } from '../LudoConstants';

export default function LudoOverlay({ phase, rankings, players, onNewMatch, isHost }) {
  if (phase !== 'match_over') return null;

  return (
    <div className="phase-overlay" style={{
      position: 'absolute',
      top: 0, left: 0, width: '100%', height: '100%',
      background: 'rgba(0,0,0,0.85)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(10px)'
    }}>
      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="rankings-card"
        style={{
          background: 'var(--glass-bg)',
          padding: '40px',
          borderRadius: '24px',
          border: '1px solid rgba(255,255,255,0.1)',
          textAlign: 'center',
          boxShadow: '0 20px 50px rgba(0,0,0,0.5)'
        }}
      >
        <h1 style={{ color: 'var(--neon-blue)', marginBottom: '30px', fontSize: '2.5rem' }}>MATCH OVER</h1>
        
        <div className="rankings-list" style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '40px' }}>
          {rankings.map((pIdx, rank) => (
            <div key={pIdx} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              padding: '15px 30px',
              background: 'rgba(255,255,255,0.05)',
              borderRadius: '12px',
              borderLeft: `5px solid ${getColor(pIdx)}`
            }}>
              <span style={{ fontSize: '1.5rem', fontWeight: 'bold', width: '30px' }}>{rank + 1}</span>
              <img src={players[pIdx]?.avatar || '/assets/avatars/default/1.png'} alt="" style={{ width: '40px', height: '40px' }} />
              <span style={{ fontSize: '1.2rem', flex: 1, textAlign: 'left' }}>{players[pIdx]?.name}</span>
            </div>
          ))}
        </div>

        {isHost && (
          <button className="btn btn-primary" onClick={onNewMatch} style={{ padding: '12px 40px', fontSize: '1.1rem' }}>
            New Match
          </button>
        )}
      </motion.div>
    </div>
  );
}
